// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"f0119351","513":"b4c3a950","981":"1d86decb"}[chunkId] + ".chunk.js";
};